import { Fragment, FunctionComponent } from "react";
import { DayOfWeek, TimeSpans } from "../api";
import { dateUtils } from "../date-utils";
import { numberUtils } from "../number-utils";

const formatDaysOfWeek = (
  daysOfWeek: DayOfWeek[],
  localizationFn: (i: number) => string
): string =>
  formatSegments(
    daysOfWeek.map((x) => Object.values(DayOfWeek).indexOf(x) + 1),
    localizationFn
  );

const formatSegments = (
  arr: number[],
  localizationFn: (i: number) => string
): string => {
  const segments = numberUtils.splitIntoSegments(arr);

  const strArray = segments.map((x) => {
    return Array.isArray(x)
      ? `${localizationFn(x[0])} - ${localizationFn(x[1])}`
      : localizationFn(x);
  });

  return strArray.join(", ");
};

const formatTimeSpan = (
  timeOfDayStart: string | null,
  timeOfDayEnd: string | null,
  locales?: Intl.LocalesArgument
) =>
  `${dateUtils.toLocalUiStringHoursMinutes(
    dateUtils.parseHoursMinutes(timeOfDayStart ?? "00:00"),
    locales
  )} - ${dateUtils.toLocalUiStringHoursMinutes(
    dateUtils.parseHoursMinutes(timeOfDayEnd ?? "00:00"),
    locales
  )}`;

const weekDaysNum: { [code: number]: string } = {
  1: "Mon",
  2: "Tue",
  3: "Wed",
  4: "Thu",
  5: "Fri",
  6: "Sat",
  7: "Sun",
};

const months: { [code: number]: string } = {
  1: "January",
  2: "February",
  3: "March",
  4: "April",
  5: "May",
  6: "June",
  7: "July",
  8: "August",
  9: "September",
  10: "October",
  11: "November",
  12: "December",
};

export const PolicyTimeSpans: FunctionComponent<{
  timeSpans?: TimeSpans[] | null;
}> = ({ timeSpans }) => {
  return (
    <>
      {timeSpans?.map((x, index) => (
        <Fragment key={index}>
          {(x.StartDate || x.EndDate) && (
            <span>
              {(x.StartDate && dateUtils.toLocalUiString(x.StartDate)) ||
                "\u223E"}{" "}
              -{(x.EndDate && dateUtils.toLocalUiString(x.EndDate)) || "\u223E"}
            </span>
          )}
          {!!x.DaysOfWeek?.length && (
            <span>{formatDaysOfWeek(x.DaysOfWeek, (x) => weekDaysNum[x])}</span>
          )}
          {!!x.Months?.length && (
            <span>{formatSegments(x.Months, (x) => months[x])}</span>
          )}
          {(x.TimeOfDayStart || x.TimeOfDayEnd) && (
            <span>
              {formatTimeSpan(x.TimeOfDayStart, x.TimeOfDayEnd, "en-US")}
            </span>
          )}

          {x.DesignatedPeriod && (
            <span>
              {x.DesignatedPeriodExcept && "no"}
              {x.DesignatedPeriod}
            </span>
          )}
        </Fragment>
      ))}
    </>
  );
};
